export default __webpack_public_path__ + "static/media/Rippling.d825b7ff.svg";